import React from 'react';

const PhoneMockup = ({ src }) => (
  <div className="relative w-full aspect-[9/19.5] bg-[#111111] rounded-[2rem] md:rounded-[2.5rem] p-2 border-[3px] border-[#6b7280] shadow-[0_20px_50px_rgba(0,0,0,0.4)] transform transition-transform duration-500 hover:-translate-y-2 cursor-pointer">
    {/* Notch Area */}
    <div className="absolute top-2 left-1/2 -translate-x-1/2 w-[45%] h-4 md:h-5 bg-[#111111] rounded-b-[1rem] z-10 flex justify-center items-center gap-1.5">
      <div className="w-6 h-1 rounded-full bg-[#333333]" />
      <div className="w-1 md:w-1.5 h-1 md:h-1.5 rounded-full bg-[#333333]" />
    </div>
    {/* Screen */}
    <div className="w-full h-full bg-white rounded-[1.5rem] md:rounded-[2rem] overflow-hidden relative">
      <img src={src} className="w-full h-full object-cover" alt="Mobile App View" />
    </div>
  </div>
);

export default PhoneMockup;
